import { Component, isDevMode } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { trackSentryUser } from '@services';

@Component({
  imports: [RouterOutlet],
  selector: 'app-root',
  template: `
    <router-outlet />
    @if (isDev) {
      <div class="dev">DEV BUILD</div>
    }
  `,
  styles: [
    `
      .dev {
        background-color: red;
        color: white;
        font-size: 12px;
        position: fixed;
        padding: 2px;
        right: -8vw;
        text-align: center;
        transform: rotate(45deg);
        width: 19vw;
        top: 1vw;
        pointer-events: none;
        z-index: 2000;
      }
    `,
  ],
})
export class App {
  protected isDev = isDevMode();

  constructor() {
    // Tag Sentry events with the uid (and tenant/role) of the logged-in user.
    trackSentryUser();
  }
}
